<template>
  <div :class="{ 'table-hidden' : !isTableVisible}">

    <h2>{{this.componentid}}</h2>
    <p class="main-intro-text">Die hier verwendeten Daten sind die in den <i>Literatur in der SBZ/DDR. Bibliographische Annalen 1945–1990 (de Gruyter: Berlin u. a. 2021)</i> erfassten Publikationen für die IfL-Direktstudierenden, die uns von der Berlin-Brandenburgischen Akademie der Wissenschaften als Datensatz zur Verfügung gestellt wurden.</p>
    
    <div class="container-table-charts">
    <div class="filter-and-charts-container" :class="this.componentid">

      <label class="loading-label">Daten werden geladen...</label>

      <div id="filter-overview-title" style="display:flex">
<!--          <h3 style="margin-top: 2px;">Filterüberblick</h3>-->
<!--          <span id="infoButton-filter-overview"></span>-->
      </div>
      <div class="filter-container">
        <div class="filter-section" > 
          <div class="filter-card-title" v-if="this.externalFilters.length > 0" >
          <h4 class="filter-head" style="display:inline-block">Filter aus anderen Tabs</h4>
          <span id="infoButton-externalfilter">
              <button @click="toggleInfo" type="button"  class="chartInfoIcon">&#9432;</button>
              <span v-if="isInfoVisible" class="chartInfoText" style="width:25em">Die externen Filter zeigen die ausgewählten Filter aus anderen Tabs an.</span>
          </span>
        </div>
          <div ref="externalFiltersRoot" />
        </div>
        <div class="filter-section" >
          <div class="local-filter-card-title" v-if="Object.keys(this.localFilterState).length > 0">
            <h4 class="filter-head" style="display:inline-block">Lokale Filter</h4>
            <div class="btn-active-filter-number">{{countActiveFilter(this.localFilterState)}}</div>
            <span id="infoButton-localfilter">
              <button @click="toggleInfo" type="button" id="infobutton-localfilter" class="chartInfoIcon">&#9432;</button>
              <span v-if="isInfoVisible" id="infotext-localfilter" class="chartInfoText">Die lokalen Filter zeigen die ausgewählten Filter des aktuellen Tabs an.</span>
            </span>
          </div>
          <div ref="localFiltersRoot" />
        </div>
    </div>

    <div ref="chartsRoot" class="chart-container">
      <div style="display:flex">
<!--        <h3>Daten</h3>-->
        <div class="active-persons" style="display: block">Ausgewählte Personen: {{ currentActivePersons.size }}</div>
      </div>

      <div>
        <button class="btn-show-chart" v-for="chartId in chartOrder" v-bind:key="chartId" v-html="chartTitles[chartId]"
                @click="showOrRemoveChartInView(chartId)" :class="{ active: isOpen(chartId) }"></button>
<!--        <button @click="toggleTableVisibility" class="btn-show-chart" :class="{active: isTableVisible}">-->
<!--          {{ isTableVisible ? 'Autor:innen-Tabelle ausblenden' : 'Autor:innen-Tabelle' }}-->
<!--        </button>-->
      </div>

      <div class="break"></div>

      <div class="flex-chart-container-publications" :class="this.componentid">
<!--        <div v-for="chartId in Object.keys(chartIsOpen).filter(key => chartIsOpen[key])" v-bind:key="chartId">-->
<!--            <div :id="'chartInfoButton-' + chartId"></div>-->
<!--            <div v-html="chartTitlesExpanded[chartId]"></div>-->
<!--            <div :id="chartId" />-->
<!--        </div>-->
      </div>
    </div>
    </div>

    <!-- Table Section, visible based on isTableVisible -->
<!--    <div v-show="true" ref="tableRoot" class="table-container" :style="{ width: tableWidth + '%' }">-->
        <div v-show="true" ref="tableRoot" class="table-container-events">
      <div class="table-controls">
        <div class="table-search">
          <label class="table-label-input" for="searchInput">Suche:</label>
          <input id="searchInput" type="text" v-model="searchTerm">
        </div>

<!--        <div class="table-size-controls">
&lt;!&ndash;          <label style="margin-right: 5px;">Tabelle Größe:</label>&ndash;&gt;
          <button class="table-controls-btn" @click="decreaseWidth" style="margin-right: 5px;">-</button>
          <span style="margin-right: 5px;">{{ tableWidth }}%</span>
          <button class="table-controls-btn" @click="increaseWidth">+</button>
        </div>-->

        <!-- Download Button -->
        <div class="table-download-controls">
          <button @click="confirmDownload" class="table-download" data-title="Download data"><i class="fa fa-download"></i></button>
        </div>

      </div>

      <!-- Column Visibility Toggle as Bubbles-->
      <div class="table-column-controls">
        <div>
    <span
        v-for="(header, index) in tableHeaders"
        :key="index"
        @click="toggleColumnVisibility(header.value)"
        :class="['column-bubble', { active: columnVisibility[header.value] }]"
    >
      {{ header.text }}
    </span>
        </div>
      </div>

      <!-- EasyDataTable -->
      <EasyDataTable ref="easyDataTable" :current-page="currentPage" buttons-pagination alternating multi-sort :headers="filteredTableHeaders"
                     :items="filteredTableData" :items-per-page="itemsPerPage"
                     :sort-by="sortBy"
                     :sort-type="sortType">
      </EasyDataTable>
    </div>
  </div>
  </div>
</template>

<script>
import * as dc from 'dc';
// eslint-disable-next-line no-unused-vars
import * as d3 from 'd3';
// eslint-disable-next-line no-unused-vars
import * as dcleaflet from 'dc.leaflet'
import crossfilter from 'crossfilter2';
import 'leaflet/dist/leaflet.css'; // Import Leaflet CSS
// eslint-disable-next-line no-unused-vars
import L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import './css/dc.css';
import './css/main.css';
//import {lineChart} from "dc";
//import * as functions from "@/lib/SharedFunctions";
//import * as constants from "@/lib/SharedConstants";
import * as effunctions from "@/lib/SharedExternalFiltersFunctions"
import * as charts from "@/lib/SharedChartCreators";
import * as DEPLOYMENT from "@/lib/DeploymentConfiguration";
import { EventBus } from '../lib/EventBus';
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import {confirmDownload, convertToCSV, downloadTableAsCSV, filterTableData} from "@/lib/SharedFunctions";
import {
  MODE_CHECKBOX,
  MODE_TEXTINPUT_AUTOCOMPLETE,
  MODE_TEXTINPUT_DROPDOWN_SELECT,
  MODE_TEXTINPUT_TIME_INTERVAL,
  TextChart
} from "@/lib/TextChart";


let instancecount = 0;

/* eslint-disable no-unused-vars */
export default {
  name: 'PublicationsView',
  components: {
    EasyDataTable
  },
  data() {
    return {
      cf: null,
      mycharts: [],
      markers: null,
      allPublications: [],
      chartGroup: dc.constants.DEFAULT_CHART_GROUP,
      tableData: [],
      searchResults: null,
      //isTableVisible: false,
      isInfoVisible: false,
      tableWidth: 50, // Default width
      pendingFilteredPersonsFromEvent: null,
      externalFilterApplied: false,
      savedFilterPersons: null,
      searchTerm: '',     
      itemsPerPage: 25,
      tableHeaders: [
        { text: 'Autor*in', value: 'protagonistLabel', sortable: true },
        { text: 'Publikationsrolle', value: 'role', sortable: true },
        { text: 'Titel', value: 'title', sortable: true },
        { text: 'Verlag', value: 'publisher', sortable: true },
        { text: 'Erscheinungsjahr', value: 'begin', sortable: true },
        { text: 'Typ', value: 'type', sortable: true }
      ],
      // Track visibility of each column
      columnVisibility: {
        begin: true,
        //id: true,
        protagonistLabel: true,
        publisher: true,
        role: true,
        title: true,
        type: true
      },

      sortBy: [],
      sortType: ["asc", "desc"],
      chartOrder: [
      //'barchat-publications-authors',
      //'chart-container-pubrole',
      //'chart-container-publisher',
      //'timeline-publications',
      'autocomplete-chart-persons',
      'checkbox-chart-roles',
      'autocomplete-chart-publishers',
      //'dropdown-chart-persons',
      'timeinterval-chart-persons',
      ],
      chartTitles: {
      'chart-container-publisher': 'Verlage',
      'chart-container-pubrole': 'Publikationsrollen',
      'barchat-publications-authors': 'Autor*innen',
      'timeline-publications': 'Erscheinungsjahr',
      'checkbox-chart-roles': 'Publikationsrollen',
      'autocomplete-chart-publishers': 'Verlage',
      'autocomplete-chart-persons': 'Autor*innen',
      'dropdown-chart-persons': 'Autor*innen',
      'timeinterval-chart-persons': 'Erscheinungsjahr',
    },
      chartTitlesExpanded: {
        'chart-container-publisher': 'Verlage nach Beitragsanzahl',
        'chart-container-pubrole': 'Publikationsrollen nach Personenanzahl',
        'barchat-publications-authors': 'Autor*innen (Top 15 nach Beitragsanzahl)',
        'timeline-publications': 'Timeline nach Personenanzahl',
        'checkbox-chart-roles': 'Publikationsrollen (Personenanzahl)',
        'autocomplete-chart-publishers': 'Verlage (Beitragsanzahl)',
        'autocomplete-chart-persons': 'Autor*innen (Beitragsanzahl)',
        'dropdown-chart-persons': 'Autor*innen (Beitragsanzahl)',
        'timeinterval-chart-persons': 'Erscheinungsjahr',

      },
      chartIsOpen: {
        'chart-container-publisher': false,
        'chart-container-pubrole': false,
        'barchat-publications-authors': false,
        'timeline-publications': false,
        'autocomplete-chart-persons': true,
        'checkbox-chart-roles': true,
        'autocomplete-chart-publishers': true,
        'dropdown-chart-persons': false,
        'timeinterval-chart-persons': true,
      },
      filterAttributeToFilterState : {
      'Verlage':'publicationsByPublishers',
      'Publikationsrollen':'rolesByPublications',
      'Autor*innen':'publicationForAuthorsTopN',
      'Timeline (Publikation)': 'timelineByNumberOfAuthors',
      'Aus anderen Tabs': 'activeExternalFilters',
      'Checkboxrollen': 'rolesByPublicationsCheckbox',
      'Dropdownpublisher' : 'publicationsByPublishersDropdown',
      'Autocompletepersonen': 'publicationForAuthorsAutocomplete',
      'Dropdownpersonen': 'publicationForAuthorsDropdown',
      'Timeinterval (Publikation)': 'timeintervalByNumberOfAuthors',
      },
     filterStateToChartRegisterAnchor : {
        'publicationsByPublishers': 'chart-container-publisher' ,
        'authorsForPublishers': 'barchart-authors-publishers' ,
        'rolesByPublications': 'chart-container-pubrole',
        'publicationForAuthorsTopN': 'barchat-publications-authors',
        'timelineByNumberOfAuthors': 'timeline-publications',
        'rolesByPublicationsCheckbox': 'checkbox-chart-roles',
        'publicationsByPublishersDropdown': 'autocomplete-chart-publishers',
        'publicationForAuthorsAutocomplete': 'autocomplete-chart-persons',
        'publicationForAuthorsDropdown': 'dropdown-chart-persons',
        'timeintervalByNumberOfAuthors': 'timeinterval-chart-persons'
      },
      chartsVisibility: {
        'chart-container-publisher': {
          // the creator functions need to return the chart object in order for toggleChart() to work
          creatorfunc: () => this.createPieChartNumberOfPublicationsByPublishers(),
        },
        'chart-container-pubrole': {
          creatorfunc: () => this.createBarChartForRoles(),
        },
        'barchat-publications-authors': {
          creatorfunc: () => this.createBarChartNumberOfPublicationsForAuthorsTopN(),
        },
        'timeline-publications': {
          creatorfunc: () => this.createTimelineChartNumberOfAuthors(),
        },
        'checkbox-chart-roles': {
          creatorfunc: () => this.createCheckboxChartForRoles(),
        },
        'autocomplete-chart-publishers': {
          creatorfunc: () => this.createDropdownChartForPublishers(),
        },
        'autocomplete-chart-persons': {
          creatorfunc: () => this.createAutocompleteChartForPersons(),
        },
        'dropdown-chart-persons': {
          creatorfunc: () => this.createDropdownChartForPersons(),
        },
        'timeinterval-chart-persons': {
          creatorfunc: () => this.createTimeIntervalChartForPersons()
        }
      },
    };
  },
  computed: {
    filteredTableData() {
      console.log("filteredTableData()");
      return filterTableData(this.tableData, this.searchTerm, this.columnVisibility);
    },
    // Filtered table headers based on visibility
    filteredTableHeaders() {
      console.log("filteredTableHeaders()");
      return this.tableHeaders.filter(header => this.columnVisibility[header.value]);
    }

  },

  methods: {
    toggleInfo() {
      this.isInfoVisible = !this.isInfoVisible;
    },
    countActiveFilter(obj) {
      let count = 0;
      for (let key in obj) {
        console.log('TESTTEST: ', obj[key])
          if (obj[key].size > 0 || Object.keys(obj[key]).length > 0) {
            count ++;
          }}
          return count;
    },
    chartInfoButtonOnClick(button, textDiv) {
      button.on("click", function() {
        var display = textDiv.style("display");
        textDiv.style("display", display === "none" ? "block" : "none");
      });
    },
    filterOverviewInfoButtonOnClick() {
      var infoButton = d3.select("#infoButton-filter-overview")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "filterOverviewInfoIcon")
        .html("&#9432;");
      // Append a div for the info text
      var infoTextDiv = d3.select("#infoButton-filter-overview")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "filterOverviewInfoText")
        .style("display", "none") 
        .text("Um einen Filter zu setzen, klicken Sie bitte auf die Diagramme.");

      infoButton.on("click", function() {
        infoTextDiv.style("display", infoTextDiv.style("display") === "none" ? "block" : "none");
      });
    },
    toggleChart(chartID) {
      console.log("toggleChart(): ", chartID);
      // check whether the chart has already been created
      const chartSelector = "#" + chartID + " svg";
      console.log("toggleChart(): chartSelector: ", chartSelector);
      const chartElement = this.chartsRoot.querySelector(chartSelector);
      console.log("toggleChart(): chartElement: ", chartElement);
      // the rendering of the charts is moved to updateAllChartsDisplay
      localStorage.setItem(this.componentid + ".chartsVisibility", JSON.stringify(this.chartsVisibility));
      this.updateAllChartsDisplay();
    },
    isOpen(chartID) {
      if (this.chartIsOpen[chartID] == true) {
        return chartID
      }
    },
    updateAllChartsDisplay() {
      console.log("updateAllChartsDisplay()");
      // this cannot be done by vue because vue component lifecycle interferes in a hardly controllably with
      // what we do underneath of vue

      // <div v-for="chartId in Object.keys(chartIsOpen).filter(key => chartIsOpen[key])" v-bind:key="chartId">
      //   <div
      //   :id="'chartInfoButton-' + chartId"></div>
      // <div v-html="chartTitlesExpanded[chartId]"></div>
      // <div :id = "chartId" / >
      //     < /div>
      const rootSelector = ".flex-chart-container-publications." + this.componentid;
      const root = document.querySelector(rootSelector);
      if (!root) {
        console.log("updateAllChartsDisplay(): root does not exist yet. Do not continue chart display for root selector: ",rootSelector);
        return;
      }
      console.log("updateAllChartsDisplay(), root: ", root);
      root.innerHTML = "";
      console.log("updateAllChartsDisplay(), cleared root: ", root.innerHTML);

      Object.keys(this.chartIsOpen)
          .filter(chartid => this.chartIsOpen[chartid])
          .forEach(chartid => {
            console.log("updateAllChartsDisplay(), will display chart: ", chartid);
            // wrapper for the chart
            const chartCard = document.createElement("div");
            // info button
            const chartInfoButton = document.createElement("div");
            chartInfoButton.id="chartInfoButton-" + chartid;
            chartCard.appendChild(chartInfoButton);
            // title
            const chartTitle = document.createElement("div");
            chartTitle.innerText = this.chartTitlesExpanded[chartid];
            chartCard.appendChild(chartTitle);
            // the chart itself - this element will be accessed as parent
            // from within the chart implementations
            const chartRoot = document.createElement("div");
            chartRoot.id = chartid;
            chartRoot.classList.add("expl-chart-root");
            chartCard.appendChild(chartRoot);

            // finally add the card to the display
            root.appendChild(chartCard);

            console.log("updateAllChartsDisplay(): mycharts are: ", this.mycharts);

            // we somehow need to make the charts identifiable if this has not been done already
            const existingChart =
                this.mycharts.filter(chart => chart.chartid == chartid)[0];
            console.log("updateAllChartsDisplay(): found existing chart: ", existingChart);

            if (!existingChart) {
              console.log("updateAllChartsDisplay(): will create a new chart for: ", chartid);
              // 1. call the creator function for which the chart has been registered
              let chartOrCharts = this.chartsVisibility[chartid].creatorfunc();
              console.log("toggleChart(): chartOrCharts: ", chartOrCharts);
              if (!Array.isArray(chartOrCharts)) {
                chartOrCharts = [chartOrCharts];
              }
              chartOrCharts.forEach(chart => {
                // 2. set the filtered listener on the chart
                chart.on("filtered", () => this.onChartFiltered());
                // 3. if the creator function cannot call render() at the very end, we might need to call it here
                console.log("toggleChart(): calling render() on: ", chart);
                chart.render();
                // the domroot attribute which is required for restoring a chart's state
                // is only available in our own chart classes (for textchart) and not in the dc charts
                if (!chart.domroot) {
                  // after rendering, we need to fetch the chart's svg and store it on the chart object
                  chart.domroot = chartRoot.querySelector("svg").parentNode;
                }
                console.log("updateAllChartsDisplay(): found chart's root dom element: ", chart.domroot);
              });
            }
            else {
              console.log("updateAllChartsDisplay(): will reuse and re-attach existing new chart for: ", chartid, existingChart);
              if (!existingChart.domroot) {
                alert("The existing chart to be inserted does not specifiy a domroot attribute!")
              }
              else {
                // charts that have been added before and have not been visible
                // for a while will be updated in the background whenever
                // filter events occur, so we only need to add the chart's domroot element
                // which will contain the updated chart
                chartRoot.appendChild(existingChart.domroot);
              }
            }
          });
    },
    showOrRemoveChartInView(chartID) {
      if (this.chartIsOpen[chartID] == true) {
        console.log('try to remove chart');
        // we do not need to remove the element ourselves because vue will handle this
        // document.getElementById(chartID).parentNode.parentNode.remove();
        this.chartIsOpen[chartID] = false;
        this.updateAllChartsDisplay();
      }
      else {
      this.chartIsOpen[chartID] = true
      setTimeout(() => {
        // Code to be executed after the delay
        console.log('Action after 2 seconds');
        this.toggleChart(chartID)
      }, 10);
    }
    },
    // toggleTableVisibility() {
    //   this.isTableVisible = !this.isTableVisible;
    //   localStorage.setItem(this.componentid + ".isTableVisible", JSON.stringify(this.isTableVisible));
    // },

    //table size customisation
    increaseWidth() {
      if (this.tableWidth < 100) {
        this.tableWidth += 5;
      }
    },
    decreaseWidth() {
      if (this.tableWidth > 30) {
        this.tableWidth -= 5;
      }
    },
    confirmDownload() {
      confirmDownload(() => this.downloadTableAsCSV());
    },
    downloadTableAsCSV() {
      const csvContent = convertToCSV(this.filteredTableData, this.tableHeaders);
      downloadTableAsCSV(csvContent, "personen_data.csv");
    },
    toggleColumnVisibility(columnKey) {
      this.columnVisibility[columnKey] = !this.columnVisibility[columnKey];
    },

    removeFilters() {
      dc.chartRegistry.list(this.componentid).forEach(chartInRegistry => {
        chartInRegistry.filter(null).render();
      });
      this.renderLocalFiltersView();
      this.externalFilters.forEach(filter => {filter.active = false});
      this.renderExternalFiltersView();
      dc.filterAll(this.componentid);
    },
    /* reducer functions for calculating groups based on the number of unique events and unique persons
    * ... and it turns out that this is slightly more complicated as expected as the performance advantage
    * of dc is, at least partially, achieved by applying the reduceRemove function when the overall set is filtered.
    * However, in cases where for some value set, e.g. authors, the values of some filter dimension (e.g. publisher) can be
    * multiply assigned, reduceRemove results in wrong results if that dimension is not foreseen in the data structure
    * underlying some chart. We observed this issue when displaying roles by number of authors being filtered for publisher.
    * Therefore, the removeAdd function now creates a result that keeps all authors for some publisher. Need to see whether,
    * reversely, we need a similar solution when using roles as filter and displaying the number of publications by publisher
    * where some author appears in that role.
    * */
    createKeyForReducer(dataitem) {
      return "_" + dataitem.publisher
        + "_" + dataitem.role
        + "_" + dataitem.begin
        + "_" + dataitem.protagonistLabel
        + "_";
    },
    reduceCountsAdd(acc, curr) {
      // we create keys that concatenate, for each element in the data set, the values
      // of the filter dimensions, we are interested in and use these concatenated strings
      // as keys in the object to be created and manipulated by the reduce functions
      const key = this.createKeyForReducer(curr);

      if (!acc[key]) {
        acc[key] = {
          uniquePublications: new Set(),
          uniqueAuthors: new Set()
        }
      }
      acc[key].uniquePublications.add(curr.id);
      acc[key].uniqueAuthors.add(curr.protagonistLabel);

      return acc;
    },

    reduceCountsRemove(acc, curr) {
      const key = this.createKeyForReducer(curr);

      // this check has been introduced on using the fake dimension for the author barchart
      // where not all data is present anymore - however, this results in data being corrupted
      // as figures will only be correct if add and remove are applied to the complete data set
      // if (acc[key]) {
      acc[key].uniquePublications.delete(curr.id);
      acc[key].uniqueAuthors.delete(curr.protagonistLabel);
      return acc;
    },

    reduceCountsInitial() {
      return {}
    },

    createBarChartForRoles() {
      var infoButton = d3.select("#chartInfoButton-chart-container-pubrole")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-chart-container-pubrole")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none")
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)
      // depending on the type of chart, we create a new attribute in localFilterState and instantiate
      // it accordingly (for barCharts and pieCharts we will use a set that contains the values that are
      // currently filtered-in)
      this.localFilterState.rolesByPublications = new Set()
      const chart = charts.createBarChart(this.componentid, this.cf,
        //this.myroot.querySelector("#chart-container-pubrole"),
        this.chartsRoot.querySelector("#chart-container-pubrole"),
        "role",
        this.reducersForPublications,
        this.getAuthorsCountFromReducedValue,
        {
          xLabel: "Rolle",
          yLabel: "Anzahl Personen"
        },
        { top: 30, right: 0, bottom: 100, left: 50 },
        { filterState: this.localFilterState.rolesByPublications }
      );

      chart.chartid = "chart-container-pubrole"
      this.mycharts.push(chart);
      return chart;
    },

    getPublicationsCountFromReducedValue(d) {
      return Object.values(d.value)
        .map(val => val.uniquePublications)
        .reduce((acc, curr) => {
          curr.forEach(el => acc.add(el));
          return acc;
        }, new Set()).size;
    },

    getAuthorsCountFromReducedValue(d) {
      return Object.values(d.value)
        .map(val => val.uniqueAuthors)
        .reduce((acc, curr) => {
          curr.forEach(el => acc.add(el));
          return acc;
        }, new Set()).size;
    },

    /* pie chart example from the events chart */
    createPieChartNumberOfPublicationsByPublishers() {
      var infoButton = d3.select("#chartInfoButton-chart-container-publisher")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-chart-container-publisher")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none")
        .text("Fahren Sie mit der Maus über ein Tortenstück, um dessen Bezeichnung anzuzeigen. Zur Filterung Tortenstück anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      console.log("createPieChartNumberOfPublicationsByPublishers(): this.chartsRoot is: ", this.chartsRoot);
      const publisherDimension = this.cf.dimension((d) => d.publisher);
      const publicationsByPublishersCount = publisherDimension.group().reduce(this.reduceCountsAdd, this.reduceCountsRemove, this.reduceCountsInitial);

      this.localFilterState.publicationsByPublishers = new Set()
      const chart = charts.createPieChart(this.componentid, 
        this.chartsRoot.querySelector("#chart-container-publisher"),
        publisherDimension,
        publicationsByPublishersCount,
        this.getPublicationsCountFromReducedValue,
        { cap: 25, filterState: this.localFilterState.publicationsByPublishers }
      );
      chart.chartid = "chart-container-publisher";
      this.mycharts.push(chart);
      return chart;
    },


    createTimelineChartNumberOfAuthors() {
      var infoButton = d3.select("#chartInfoButton-timeline-publications")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-timeline-publications")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none")
        .text("Zeiträume können durch Mausnutzung ausgewählt werden.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const publicationsWithDate = this.data.filter(pub => pub.begin).filter(pub => !isNaN(pub.begin));

      // the date dimension: we start using single years rather than year intervals
      // NOTE: the dateDimension must return either Date objects or timestamps in milliseconds. If we
      // retur the value of pub.begin (which is years), it will be interpreted as milliseconds, and we end up
      // with all values be placed around 1970
      const dateDimension = this.cf.dimension(pub => pub.begin && pub.begin != "null"
        ? new Date(pub.begin, 1, 1).getTime()
        : new Date(2000, 1, 1).getTime());

      // the grouping for the date dimension: 
      const yearGroup = dateDimension.group().reduce(this.reduceCountsAdd, this.reduceCountsRemove, this.reduceCountsInitial);

      this.localFilterState.timelineByNumberOfAuthors = {
        from: null,
        to: null
      };
      const chart = charts.createTimelineChart(
        this.componentid, 
        this.chartsRoot.querySelector('#timeline-publications'),
        dateDimension,
        yearGroup,
        this.getAuthorsCountFromReducedValue,
        publicationsWithDate,
        { filterState: this.localFilterState.timelineByNumberOfAuthors }
      );
      chart.chartid = "timeline-publications";
      this.mycharts.push(chart);
      return chart;
    },

    // add new checkbox chart for roles
    createCheckboxChartForRoles() {
      const roleDimension = this.cf.dimension(d => d.role);
      const roleGroup = roleDimension.group().reduce(
          this.reduceCountsAdd,
          this.reduceCountsRemove,
          this.reduceCountsInitial
      );

      const valueAccessor = d => this.getAuthorsCountFromReducedValue(d);

      const chartId = 'checkbox-chart-roles';
      const parentSelector = `#${chartId}`;

      this.localFilterState.rolesByPublicationsCheckbox = new Set();

      const chart = new TextChart(parentSelector, valueAccessor, 'role', this.componentid, )
          .dimension(roleDimension)
          .group(roleGroup)
          .valueAccessor(valueAccessor)
          .filterState(this.localFilterState.rolesByPublicationsCheckbox)
          .mode(MODE_CHECKBOX)
          .showSelectButtons(true)
          .chartGroup(this.chartGroup);
          //.title('Select Roles');

      // Handle filters dynamically
      // chart.on('filtered', () => {
      //   this.localFilterState.rolesByPublications = new Set(chart.filters());
      //   this.renderLocalFiltersView();
      //   dc.redrawAll('__default_chart_group__');
      // });

      // Register the `onFiltered` callback
      chart.onFiltered = () => this.onChartFiltered();

      chart.chartid = chartId;

      this.mycharts.push(chart);
      return chart;
    },

    createDropdownChartForPublishers() {
      const publisherDimension = this.cf.dimension(d => d.publisher);
      const publisherGroup = publisherDimension.group().reduceCount();

      const chartId = 'autocomplete-chart-publishers';
      const parentSelector = `#${chartId}`;

      this.localFilterState.publicationsByPublishersDropdown = new Set();

      // Initialize TextChart in dropdown mode for publishers
      const chart = new TextChart(parentSelector)
          .dimension(publisherDimension)
          .group(publisherGroup)
          .chartGroup(this.chartGroup)
          .valueAccessor(d => d.value)
          .filterState(this.localFilterState.publicationsByPublishersDropdown)
          .mode(MODE_TEXTINPUT_AUTOCOMPLETE)
          .title('Select Publishers');

      chart.chartid = chartId;
      chart.onFiltered = () => this.onChartFiltered();

      this.mycharts.push(chart);
      return chart;
    },


    createAutocompleteChartForPersons() {
      // Define the dimension and group for persons, same as in createBarChartForPersons
      const personDimensionautocomplete = this.cf.dimension(d => d.protagonistLabel);
      const personGroupautocomplete = personDimensionautocomplete.group().reduceCount();

      const chartId = 'autocomplete-chart-persons';
      const parentSelector = `#${chartId}`;

      this.localFilterState.publicationForAuthorsAutocomplete = new Set();

      // Initialize TextChart in autocomplete mode for persons
      const chart = new TextChart(parentSelector)
          .dimension(personDimensionautocomplete)
          .group(personGroupautocomplete)
          .chartGroup(this.chartGroup)
          .valueAccessor(d => d.value)
          .filterState(this.localFilterState.publicationForAuthorsAutocomplete)
          .mode(MODE_TEXTINPUT_AUTOCOMPLETE)
          .title("Select Authors");

      chart.chartid = chartId;

      chart.onFiltered = () => this.onChartFiltered();

      this.mycharts.push(chart);
      return chart;
    },

    createDropdownChartForPersons() {
      const personDimensiondropdown = this.cf.dimension(d => d.protagonistLabel);
      const personGroupdropdown = personDimensiondropdown.group().reduceCount();

      const chartId = 'dropdown-chart-persons';
      const parentSelector = `#${chartId}`;

      this.localFilterState.publicationForAuthorsDropdown = new Set();


      // Initialize TextChart in dropdown mode for persons
      const chart = new TextChart(parentSelector)
          .dimension(personDimensiondropdown)
          .group(personGroupdropdown)
          .chartGroup(this.chartGroup)
          .valueAccessor(d => d.value)
          .filterState(this.localFilterState.publicationForAuthorsDropdown)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Select Authors");

      chart.chartid = chartId;

      chart.onFiltered = () => this.onChartFiltered();

      this.mycharts.push(chart);
      return chart;
    },

    createTimeIntervalChartForPersons() {

      const chartId = 'timeinterval-chart-persons';
      const parentSelector = `#${chartId}`;

      // Define the date dimension directly as years (integer values)
      const dateDimensiontimeInterval = this.cf.dimension(pub => {
        return pub.begin && pub.begin !== "null" && !isNaN(pub.begin)
            ? parseInt(pub.begin, 10)  // Use the actual year if it's valid
            : 3000;                    // Assign 2000 as the placeholder for invalid dates
      });

      // Group the data by year
      const dateGrouptimeInterval = dateDimensiontimeInterval.group().reduce(
          this.reduceCountsAdd,
          this.reduceCountsRemove,
          this.reduceCountsInitial
      );
      this.localFilterState.timeintervalByNumberOfAuthors = new Set();

      // Initialize TextChart in dropdown mode for persons
      const chart = new TextChart(parentSelector)
          .dimension(dateDimensiontimeInterval)
          .group(dateGrouptimeInterval)
          .chartGroup(this.chartGroup)
          .valueAccessor(d => d.value)
          .filterState(this.localFilterState.timeintervalByNumberOfAuthors)
          //.setYearRange(minYear, maxYear)
          .mode(MODE_TEXTINPUT_TIME_INTERVAL)
          .title("Select Years");

      chart.chartid = chartId;

      chart.onFiltered = () => this.onChartFiltered();

      //this.timeIntervalChart.setYearRange(minYear, maxYear);
      this.mycharts.push(chart);
      return chart;
    },


    // taken from: https://stackoverflow.com/questions/30977987/plotting-top-values-of-a-group-on-dc-js-bar-chart
    // this constrains a group to the n topmost values - note, however, that here the reducer-objects do not seem to
    // be used, i.e. the ranking is based on the overall counts (need to see whether this is the case also for the
    // other charts)
    // see https://github.com/dc-js/dc.js/wiki/FAQ#filter-the-data-before-its-charted for an
    // "offical" recommendation of such "fake groups" that can be used if data needs to be preprocessed
    // see also here: https://groups.google.com/g/dc-js-user-group/c/zwS6bisSofE?pli=1
    // before being displayer
    // see also: https://groups.google.com/g/dc-js-user-group/c/zwS6bisSofE
    //
    // none of the proposed solutions works, included passing the top-N authors as domain - here
    // all other authors will be placed at x=0 and can be filtered out in CSS, but the domain,
    // even if updated regularly will be overridden by the elasticX feature, which will
    // automatically result in using the whole data set as basis for drawing the graph.
    // Therefore, we draw the graph and after drawing rearrange the bars, which is, unfortunately,
    // rather heavy as it included dom manipulations
    //
    // both fake groups and fake dimensions result in trouble when it comes to
    // applying the filter reducers
    createBarChartNumberOfPublicationsForAuthorsTopN() {
      var infoButton = d3.select("#chartInfoButton-barchat-publications-authors")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-barchat-publications-authors")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none")
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      this.localFilterState.publicationForAuthorsTopN = new Set()
      const chart = charts.createBarChart(this.componentid, this.cf,
        //this.myroot.querySelector("#barchat-publications-authors"),
        this.chartsRoot.querySelector("#barchat-publications-authors"),
        "protagonistLabel",
        this.reducersForPublications,
        this.getPublicationsCountFromReducedValue,
        {
          xLabel: "Personen",
          yLabel: "Anzahl Beiträge"
        },
        { top: 30, right: 0, bottom: 100, left: 50 },
        { topN: 15, filterState: this.localFilterState.publicationForAuthorsTopN }
      );
      chart.chartid = "barchat-publications-authors";
      this.mycharts.push(chart);
      return chart;
    },
    removeLocalFilterCard(element, chart) {
     // Remove the parent element (which is the filter card)
    element.parentNode.removeChild(element);
    const filterStateChart = this.filterAttributeToFilterState[chart.split(':')[0].trim()];
    const filterStateToChartRegisterAnchor = this.filterStateToChartRegisterAnchor;

    // Update the chart: remove selected filter
    dc.chartRegistry.list(this.componentid).forEach(chartInRegistry => {
      var anchorID = chartInRegistry._anchor.id
      if ((anchorID == filterStateToChartRegisterAnchor[filterStateChart]) || filterStateToChartRegisterAnchor[filterStateChart]?.includes(anchorID)) {
        // it seems that at least for pie charts, re-rendering is required after resetting the filter
        console.log("removeLocalFilterCard(): rendering chart: ", anchorID);
        chartInRegistry.filter(null).render();
        // Update all subcharts in collection
        if (filterStateChart == 'professionsEvaluation' || filterStateChart == 'referencesEvaluation' || filterStateChart == 'institutionsEvaluation'){
          filterStateToChartRegisterAnchor[filterStateChart].forEach(subchart => {
            dc.chartRegistry.list(this.componentid).forEach(subchartInRegistry => {
              if (chartInRegistry._anchor.id == subchart) {
                console.log("removeLocalFilterCard(): rendering subchart: ",subchartInRegistry._anchor.id);
                subchartInRegistry.filter(null).render();
              }
            })
          })
        }
      }
    });

    if (filterStateChart == 'activeExternalFilters'){
      this.localFilterState.activeExternalFilters = new Set()
      this.externalFilters.forEach(filter => {
        filter.active = !filter.active;
        const applyExternalFiltersArray = effunctions.applyExternalFilters(this.localFilterState, this.externalFilters, this.initialAuthors, this.externalPersonsDimension, this.currentActivePersons, this.cf, this.mycharts, this.componentid);
          this.externalPersonsDimension = applyExternalFiltersArray[0];
          this.currentActivePersons = applyExternalFiltersArray[1];
          filter.updated = false;
          this.renderExternalFiltersView()
      })
    }

    // Update apply/remove button of the external filter card
    if (chart.includes('external filter')) {
      const componentIdExternalFilter =  chart.split(':')[1];
      this.externalFilters.forEach(filter => {
        if (filter.componentid == componentIdExternalFilter.trim()) {
          filter.active = false}
      });
    this.renderExternalFiltersView();
    }},
    renderLocalFiltersView() {
      console.log("renderLocalFiltersView() publicationsView: ", this.localFiltersRoot, this.localFilterState);
      this.localFiltersRoot.innerHTML = "";
      const filterDetailsInfo = document.createElement("div");
      
      effunctions.collectMetadataFromExternalFilters({filterState: this.localFilterState}).textContent.split(';').forEach(filter => {
        const divElement = Object.assign(document.createElement("div"), { id: filter});
        const pElement = Object.assign(document.createElement("p"), { textContent: (filter || "").replaceAll(",",", "), className: "local-filter-card"});
        const removeElement = Object.assign(document.createElement("span"), { textContent: 'x', className: "remove-each-local-filter-btn"});

        if (filter.trim() !== "") { // Check if the filter is not empty after trimming whitespaces
          removeElement.addEventListener("click", () => {
            this.removeLocalFilterCard(divElement, filter);
          });
          // TODO: at some moment, the element for removal should be shown again
          // divElement.appendChild(removeElement);
          divElement.appendChild(pElement);
          filterDetailsInfo.appendChild(divElement);
        }
      })

      this.localFiltersRoot.appendChild(filterDetailsInfo);
    },
    renderExternalFiltersView() {
      console.log("renderExternalFiltersView()", this.externalFilters);
      // reset
      this.externalFiltersRoot.innerHTML = "";
      // iterate over the filters
      this.externalFilters.forEach(filter => {
        const filterArea = document.createElement("fieldset");
        filterArea.appendChild(Object.assign(document.createElement("legend"), { textContent: filter.componentid + (filter.removed ? " [removed]" : "") }));
        // for transparency, we display the state
        filterArea.appendChild(effunctions.filterStateInfo(filter));

        // collect metadata from the external filters
        if (filter.filterState) {
          effunctions.collectMetadataFromExternalFilters(filter).textContent.split('; ').forEach(f => {
            filterArea.appendChild(Object.assign(document.createElement("div"), { textContent: f, className: 'div-ext-filters' }));
          })
        }

        // here's the main button - for applying/removing a filter
        const filterMainAction = filterArea.appendChild(Object.assign(document.createElement("button"), { textContent: filter.active ? "Entfernen" : "Anwenden", className:filter.active ? "btn-remove" : "btn-apply" }))

        filterMainAction.onclick = () => {
          console.log("filtering...");
          filter.active = !filter.active;
          const applyExternalFiltersArray = effunctions.applyExternalFilters(this.localFilterState, this.externalFilters, this.initialAuthors, this.externalPersonsDimension, this.currentActivePersons, this.cf, this.mycharts, this.componentid, this.chartGroup);
          this.externalPersonsDimension = applyExternalFiltersArray[0];
          this.currentActivePersons = applyExternalFiltersArray[1];
          // do what we need to do given the new state of the filter
          // (...)
          // refresh the filters view
          // we remove the updated attribute
          filter.updated = false;
          this.renderExternalFiltersView();
          this.updateAllChartsDisplay();
          dc.redrawAll(this.chartGroup);
        }
        if (filter.active && filter.updated) {
          // an additional action if a filter is active and has been updated
          const filterAdditionalAction = filterArea.appendChild(Object.assign(document.createElement("button"), { textContent: "Erneut anwenden", className: "btn-apply" }));
          filterAdditionalAction.onclick = () => {
            const applyExternalFiltersArray = effunctions.applyExternalFilters(this.localFilterState, this.externalFilters, this.initialAuthors, this.externalPersonsDimension, this.currentActivePersons, this.cf, this.mycharts, this.componentid, this.chartGroup);
            this.externalPersonsDimension = applyExternalFiltersArray[0];
            this.currentActivePersons = applyExternalFiltersArray[1];

            // do what we need to do, i.e. apply the new filter criteria
            // ... and refresh state+view
            filter.updated = false;
            this.renderExternalFiltersView();
            this.updateAllChartsDisplay();
            dc.redrawAll(this.chartGroup);
          }
        }
        // DO NOT FORGET TO ADD THE FILTER AREA TO THE ROOT ELEMENT...
        this.externalFiltersRoot.appendChild(filterArea);
        this.renderLocalFiltersView();
      });

      //Update table
      this.tableData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
     //this.$refs.easyDataTable.updatePage(1);
      if (this.$refs.easyDataTable) {
        this.$refs.easyDataTable.updatePage(1);
      }
    },
    
    onChartFiltered() {
      this.currentActivePersons = effunctions.getActivePersons(this.cf);
      // Update data for the tableData
      //this.tableData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
      const filteredData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
      this.tableData = filteredData;


      // Update the local filter state
      this.renderLocalFiltersView();

      console.log("Publications: emit filteredPersons", this.localFilterState);
      // here, we need to somehow tell the crosssfilter object for events that these persons shall be filtered
      EventBus.emit('filteredPersons', {
        componentid: this.componentid,
        persons: Array.from(this.currentActivePersons),
        filterState: this.localFilterState
      });
      dc.redrawAll(this.chartGroup);
      this.$refs.easyDataTable.updatePage(1)
    }
  },

  created() {
    instancecount++;
    // console.log("Publications.created(): ", this.$refs.chartsRoot, this);
    this.componentid = "Publikationen-" + instancecount;
    this.currentActivePersons = new Set();
    this.externalFilters = [];
    this.localFilterState = {};

    window.addEventListener('beforeunload', () => {
      localStorage.setItem(this.componentid + ".chartIsOpen", JSON.stringify(this.chartIsOpen));
    });

    EventBus.on("externalFilterTabRemoved", (eventpayload) => {
      if (eventpayload.componentid == this.componentid) {
        console.log("ignore event emitted by ourselves", eventpayload.componentid, this.componentid);
        return;
      }
      const existingFilterForComponentid = this.externalFilters.filter(fil => fil.componentid === eventpayload.componentid)[0];
      if (existingFilterForComponentid) {
        existingFilterForComponentid.removed = true;
        this.renderExternalFiltersView();
      }
    });
    EventBus.on('filteredPersons', (eventpayload) => {
      if (eventpayload.componentid == this.componentid) {
        console.log("ignore event emitted by ourselves", eventpayload.componentid, this.componentid);
        return;
      }
      // Speichern der empfangenen Daten in der pendingFilteredPersonsFromEvent Variable
      this.pendingFilteredPersonsFromEvent = eventpayload.persons;
      // use external filters. First check whether we already have a filter
      // for the component that sends us the data
      const existingFilterForComponentid = this.externalFilters.filter(fil => fil.componentid === eventpayload.componentid)[0];
      if (existingFilterForComponentid) {
        //console.log("externalFilters: updating existing external filter for componentid ", eventpayload.componentid, ": ", eventpayload);
        existingFilterForComponentid.persons = eventpayload.persons;
        // updated and active can be used to handle issues #35 and #39, respectively
        existingFilterForComponentid.updated = true;
        // active=true means that the filter is currently selected and has been applied
        // for an existing filter, we will not modify the active state as it might be still selected
        // existingFilterForComponentid.active = false;
      }
      else {
        //console.log("externalFilters: adding new external filter for componentid ", eventpayload.componentid, ": ", eventpayload);
        this.externalFilters.push({ ...eventpayload });
        this.externalFilters[this.externalFilters.length - 1].active = false;
        // a new filter will not receive the updated attribute
      }
      //console.log("externalFilters are now: ", this.externalFilters);
      // we update the view HERE, i.e. we do not need to bind update to the lifecycle events like activated()
      this.renderExternalFiltersView();
      //Update table
      this.tableData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
      this.$refs.easyDataTable.updatePage(1);
    });
  },

  beforeUnmount() {
    console.log("Publications.beforeUnmount()");
  },

  unmounted() {
    console.log("Publications.unmounted()");
  },

  deactivated() {
    this.hasBeenDeactivated = true;
  },

  activated() {
    console.log("Publications.activated(): ", this.componentid, this.chartsRoot, this.externalFiltersRoot);
    const loadingLabelSelector = "." + this.componentid + " .loading-label";
    const loadingLabel = document.querySelector(loadingLabelSelector);
    console.log("loadingLabel: ", loadingLabelSelector, loadingLabel);
    if (loadingLabel && !this.data) {
      loadingLabel.classList.add("active");
    }

    const checkInterval = 250;
    const maxWaitime = 60000;
    let actualWaittime = 0;
    const checkDataAvailable = () => {
      if (this.data) {
        if (loadingLabel) {
          loadingLabel.classList.remove("active");
        }
        this.updateAllChartsDisplay()
      }
      else if (actualWaittime > maxWaitime) {
        alert("Ein unbekannter Fehler beim Laden der Daten ist aufgetreten...");
      }
      else {
        actualWaittime += checkInterval;
        setTimeout(() => checkDataAvailable(),checkInterval);
      }
    }
    checkDataAvailable();
  },

  mounted() {
    // first of all, try to get a token from the url
    const params = new URLSearchParams(window.location.search)
    const token = params.get("token");

    this.filterOverviewInfoButtonOnClick()

    this.tableRoot = this.$refs.tableRoot;
    this.chartsRoot = this.$refs.chartsRoot;
    this.externalFiltersRoot = this.$refs.externalFiltersRoot;
    this.localFiltersRoot = this.$refs.localFiltersRoot;
    console.log("Publications.mounted(): ", this, this.$refs.chartsRoot);
    console.log("Publications.mounted(): root elements have been set: ", this.tableRoot, this.chartsRoot);

    const storedState = null; 
    if (storedState) {
      this.chartIsOpen = JSON.parse(storedState);
    }
    // const storedTableVisibility = null;
    // if (storedTableVisibility !== null) {
    //   this.isTableVisible = JSON.parse(storedTableVisibility);
    // }

    const apiAccessUrl = DEPLOYMENT.getApiAccessUrl(DEPLOYMENT.PUBLICATIONS_RESOURCE,token);

    console.log("using apiAccessUrl for publications: ", apiAccessUrl);

    fetch(apiAccessUrl)
      .then((response) => response.json())
      .then((data, tableData) => {
        // prepare the data and initialise crossfilter

        // we set data as an instance attribute
        this.data = data;
        console.log('data: ', this.data)
        //this.logComparedata();

        this.initialAuthors = this.data.reduce((acc, curr) => {
          acc.add(curr.protagonistLabel);
          return acc;
        }, new Set());
        console.log("initialAuthors: ", this.initialAuthors);
        this.currentActivePersons = this.initialAuthors;

        // Initialize Crossfilter with the fetched data
        this.cf = crossfilter(this.data);

        // the reducers to be passed to all chart creator functions (once all functions have been created in SharedChartCreators)
        this.reducersForPublications = {
          reduceCountsAdd: this.reduceCountsAdd,
          reduceCountsRemove: this.reduceCountsRemove,
          reduceCountsInitial: this.reduceCountsInitial
        };


        // Show charts in view when the page is loaded 
          // and charts are open (value 'true' in chartIsOpen map)
        console.log("Publications.mounted(): will toggle all charts that shall be open", this.chartIsOpen);
        Object.keys(this.chartIsOpen).filter(key => this.chartIsOpen[key]).forEach(key => this.toggleChart(key))

        // Render charts
        dc.renderAll();
        this.tableData = this.data

        // TODO: add listener that reacts to the single filter events that occur while interacting with the visualisation
        //  here, we can update the table view of the respective data
        // see: https://stackoverflow.com/questions/22392134/is-there-a-way-to-attach-callback-what-fires-whenever-a-crossfilter-dimension-fi
        dc.chartRegistry.list(this.componentid).forEach(chart => {
          if (this.mycharts.indexOf(chart) != -1) {
            console.log("Publications: preparing for filtered listening: owner is Publications. Set listener", chart);
            chart.on("filtered", () => {
              this.onChartFiltered();
            });
          }
          else {
            console.log("Publications: preparing for filtered listening: owner is not Publications. Do not set listener", chart);
          }
        });

        // we update (rather, initialise) the external filters view
        this.renderExternalFiltersView();
      });
  }
};

</script>

